<div style="width: 400px; height: 500px;" data-cy="tooth-selector-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="tooth-selector-header-section">
      <div class="section-header-title" data-cy="tooth-selector-title-text">
        Select case / teeth
      </div>
      <div style="flex: 1;"></div>
    </div>
    <div class="section-content" style="flex: 1; overflow-y: hidden;" data-cy="tooth-selector-content-section">
      <ng-container *ngIf="casesTeeth && casesTeeth.length > 0">
        <div style="max-height: 100%; overflow-y: auto;" data-cy="tooth-selector-items-container">
          <div (click)="onCaseTeethClick(ct)" class="tooth-selector-item" [ngClass]="{'tooth-selector-item-selected': isSelectedItem(ct)}" *ngFor="let ct of casesTeeth" style="display: flex;" data-cy="tooth-selector-item">
            <div style="flex: 1;" data-cy="tooth-selector-item-date">{{getDate(ct.date)}}</div>
            <div style="flex: 1;" data-cy="tooth-selector-item-teeth">
              #
              <ng-container *ngFor="let t of ct.teeth; index as i">
                <ng-container *ngIf="i === 0">{{t}}</ng-container>
                <ng-container *ngIf="i > 0">, {{t}}</ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!casesTeeth || (casesTeeth && casesTeeth.length === 0)">
        <div data-cy="tooth-selector-no-teeth-message">This patient has no cases / teeth.</div>
      </ng-container>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 40px;" data-cy="tooth-selector-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="tooth-selector-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="tooth-selector-ok-button">Ok</button>
    </div>
  </div>
</div>
